import { render, staticRenderFns } from "./DynamicAttributeValidation.vue?vue&type=template&id=5a997ab8&"
import script from "./DynamicAttributeValidation.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports